<template>
    <div class="user_core">
        <Header :title="title"></Header>
        <van-row class="info_body">
            <van-col span="24" class="info_s">
                <van-row>
                    <van-col span="24" class="mtitle">
                        {{mdata.title}}
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="24" class="tiem">
                        {{mdata.create_time}}
                    </van-col>
                </van-row>
                <van-divider />
                <van-row>
                    <van-col span="24" class="context">
                        {{mdata.message}}
                    </van-col>
                </van-row>

            </van-col>
        </van-row>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import {getReq} from "../../utils/api";
    export default {
        name: "Detail",
        data(){
            return{
                title:"我的信息",
                mdata : [],

            }
        },
        mounted(){
            this.msgDetail()
        },
        components:{
            Header,
            Footer
        },
        methods: {
            msgDetail(){
                let id = this.$route.query.id;
                if(id){
                    getReq('/msgdetail',{id:id}).then((res)=>{
                        if(res.code==200)
                        {
                            this.mdata = res.data;
                        }
                    })
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .user_core{
        min-height: 600px;
        background: url("~@/assets/images/bg_header.png") no-repeat center 45px;
        background-size: 100% ;
        .info_body{
            width: 92%;
            min-height: 600px ;
            margin: 20px auto 0 auto;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
            .info_s {
                margin: 10px auto 40px auto;
                .mtitle{
                    margin: 10px auto;
                    font-size: 18px;
                    font-weight: bold;
                    color: #666;
                    text-align: center;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .time{
                    color: #999;
                }
                .context{
                    width: 90%;
                    margin: 10px;
                    text-align: left;
                    line-height: 30px;
                    text-indent: 25px;
                }




            }
        }
    }
</style>
